import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(finance)/finance/components/crypto/AdBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(finance)/finance/components/crypto/CryptoDetailsHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(finance)/finance/components/crypto/CryptoToRubCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsDynamic"] */ "/app/app/components/BreadcrumbsDynamic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/app/components/ui/separator.tsx");
